import { createContext, useState, useEffect } from "react"
import axios from "axios"
import config from "../config"

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null)
  const [authStatus, setAuthStatus] = useState(() => {
    //👉 Al iniciar comprueba el ultimo estado en localstorage

    return localStorage.getItem("authStatus") || ""
  })



  useEffect(() => {

    localStorage.setItem("authStatus", authStatus)
  }, [authStatus])


  useEffect(() => {


    if (authStatus === "authorized") {

      const baseURL = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL
      const userInfoEndPoint = 'Member/UserInfo'
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access-token')}`
      };

      async function fetchDataWithAxios() {
        try {

          if (localStorage.getItem('access-token')) {
            //console.log('existe access-token: ')
            const response = await axios.get(`${baseURL}${userInfoEndPoint}`, { headers });

            if (response.status === 200) {
              setUserInfo(response.data)
              if (response.data.subscriptions) {
                localStorage.setItem('TPATrainingStatus', response.data.subscriptions.TPATraining)

              }


            }


            //console.log('response info: ', response)
          }

        } catch (error) {
          console.error(error);
        }
      }

      fetchDataWithAxios()
    }

  }, [authStatus])


  // 👉 El login y las rutas protegidas pueden cambiar el estado
  const login = () => {
    setAuthStatus("authorized")
  }


  const logout = () => {

    const fetchLogOut = async () => {

      const baseURL = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL
      const logOutEndPoint = 'Authentication/logout'
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access-token')}`
      }
      try {
        if (localStorage.getItem('access-token')) {

          const response = await axios.post(`${baseURL}${logOutEndPoint}`, {}, { headers })

          if (response.status === 200) {
            localStorage.clear()
            setAuthStatus("unauthorized")

            //console.log('Cierre de sesion con exito: ')
          }

        }


      } catch (error) {
        console.error(error)
      }
    }

    fetchLogOut()



  }

  //console.log('authStatus desde el provider: ', authStatus)

  return (
    <AuthContext.Provider value={{ authStatus, login, logout, userInfo }}>
      {children}
    </AuthContext.Provider>
  )
}